import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48ea27dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 divTitulo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base fw-bold spanTitulo" }, "Detalles del apartado |", -1))
const _hoisted_3 = { style: {"color":"#8b8674 !important"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-sm" }, " Detalles del apartado", -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4" }
const _hoisted_7 = { class: "detalleVehiculo text-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  class: "text-center bgColumn",
  style: {"border-radius":"0px 0px 10px 10px"}
}
const _hoisted_10 = { class: "fs-2 fw-bold" }
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = {
  class: "accordion",
  id: "kt_accordion_1"
}
const _hoisted_13 = { class: "accordion-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "kt_accordion_1_header_1"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button fs-4 fw-bold",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_accordion_1_body_1",
    "aria-expanded": "true",
    "aria-controls": "kt_accordion_1_body_1"
  }, " Detalles del vehículo ")
], -1))
const _hoisted_15 = {
  id: "kt_accordion_1_body_1",
  class: "accordion-collapse collapse show",
  "aria-labelledby": "kt_accordion_1_header_1",
  "data-bs-parent": "#kt_accordion_1"
}
const _hoisted_16 = { class: "accordion-body text-start" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "VIN", -1))
const _hoisted_18 = { class: "textDato" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Año", -1))
const _hoisted_21 = { class: "textDato" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Marca", -1))
const _hoisted_24 = { class: "textDato" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Modelo", -1))
const _hoisted_27 = { class: "textDato" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Versión", -1))
const _hoisted_30 = { class: "textDato" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Tipo", -1))
const _hoisted_33 = { class: "textDato" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Transmisión", -1))
const _hoisted_36 = { class: "textDato" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Color", -1))
const _hoisted_39 = { class: "textDato" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Kilometraje", -1))
const _hoisted_42 = { class: "textDato" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = {
  key: 0,
  class: "mx-4 p-4 mt-5 bg-dark-site rounded me-2"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row card_header py-2 px-3" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-5 fw-bold" }, "Vehículo tomar a cuenta")
], -1))
const _hoisted_46 = { class: "row card_body pt-3 pe-3" }
const _hoisted_47 = { class: "mb-1" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "isax-car text-white" }, null, -1))
const _hoisted_49 = { class: "ms-3" }
const _hoisted_50 = { class: "mb-1" }
const _hoisted_51 = { class: "ms-7" }
const _hoisted_52 = { class: "col-xs-12 col-sm-8 col-md-8 col-lg-8 col-xl-8" }
const _hoisted_53 = { class: "row mt-5 px-8" }
const _hoisted_54 = { class: "col-xs-12 col-sm-6 col-md-6 col-lg-6 text-start mb-4" }
const _hoisted_55 = {
  key: 0,
  class: "col-xs-12 col-sm-6 col-md-6 col-lg-6 text-end"
}
const _hoisted_56 = {
  class: "ulDueno ps-0",
  style: {"display":"inline-flex"}
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", null, " Estatus: ")
], -1))
const _hoisted_58 = {
  key: 0,
  class: "ps-5",
  style: {"margin-top":"-14px"}
}
const _hoisted_59 = {
  key: 1,
  class: "col-xs-12 col-sm-6 col-md-6 col-lg-6 text-end mb-8"
}
const _hoisted_60 = { style: {"width":"245px","float":"right","margin-top":"-20px","position":"absolute","right":"4vw"} }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"40px","margin-right":"5px"} }, "Estatus", -1))
const _hoisted_62 = { class: "pe-5" }
const _hoisted_63 = {
  key: 0,
  class: "badge badge-success badge-lg mb-2 mt-2 p-4"
}
const _hoisted_64 = {
  key: 0,
  class: "col-12 text-start",
  style: {"background-color":"#393840","border-radius":"0px 0px 10px 10px"}
}
const _hoisted_65 = {
  style: {"list-style-type":"none"},
  class: "p-4"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Selecciona el estatus")
], -1))
const _hoisted_67 = { class: "mb-4" }
const _hoisted_68 = { class: "mb-4" }
const _hoisted_69 = { class: "row mt-5 px-8" }
const _hoisted_70 = {
  class: "col-xs-12 col-sm-12 col-md-6 col-lg-6",
  style: {"padding-left":"0px"}
}
const _hoisted_71 = { class: "backCard pr-2" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "titulo" }, "Datos del cliente", -1))
const _hoisted_73 = { class: "pb-5 ulDueno" }
const _hoisted_74 = { class: "mb-2" }
const _hoisted_75 = { class: "mb-2" }
const _hoisted_76 = { class: "mb-2" }
const _hoisted_77 = {
  class: "col-xs-12 col-sm-12 col-md-6 col-lg-6",
  style: {"padding-left":"0px"}
}
const _hoisted_78 = { class: "backCard" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "titulo" }, "Datos de la agencia", -1))
const _hoisted_80 = { class: "pb-4 ulDueno" }
const _hoisted_81 = { class: "mb-2" }
const _hoisted_82 = {
  style: {"display":"inline-flex"},
  class: "ulDueno p-0"
}
const _hoisted_83 = { class: "ps-3" }
const _hoisted_84 = { class: "mb-2" }
const _hoisted_85 = {
  style: {"display":"inline-flex"},
  class: "ulDueno p-0"
}
const _hoisted_86 = { class: "ps-3" }
const _hoisted_87 = { class: "mb-2" }
const _hoisted_88 = {
  style: {"display":"inline-flex"},
  class: "ulDueno p-0"
}
const _hoisted_89 = { class: "ps-3" }
const _hoisted_90 = { class: "row mt-5 px-8" }
const _hoisted_91 = {
  class: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
  style: {"padding-left":"0px"}
}
const _hoisted_92 = { class: "backCard pr-2" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "titulo" }, "Datos de la transacción y apartado", -1))
const _hoisted_94 = { class: "row" }
const _hoisted_95 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4" }
const _hoisted_96 = { class: "ulDueno pb-4 ps-0" }
const _hoisted_97 = { class: "mb-2" }
const _hoisted_98 = { class: "mb-2 ps-7" }
const _hoisted_99 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4" }
const _hoisted_100 = { class: "ulDueno pb-4 ps-0" }
const _hoisted_101 = { class: "mb-2" }
const _hoisted_102 = { class: "mb-2 ps-7" }
const _hoisted_103 = { class: "col-xs-12 col-sm-4 col-md-4 col-lg-4" }
const _hoisted_104 = { class: "ulDueno pb-4 ps-0" }
const _hoisted_105 = { class: "mb-2" }
const _hoisted_106 = { class: "mb-2 ps-7" }
const _hoisted_107 = { class: "row mt-5 px-8" }
const _hoisted_108 = {
  class: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
  style: {"padding-left":"0px"}
}
const _hoisted_109 = { class: "backCard pr-2" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "titulo" }, "Datos de la tarjeta", -1))
const _hoisted_111 = { class: "pb-2 ulDueno" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-600" }, "Tipo de tarjeta")
], -1))
const _hoisted_113 = { class: "mb-2" }
const _hoisted_114 = { class: "pb-2 ulDueno" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-600" }, "Marca")
], -1))
const _hoisted_116 = { class: "mb-2 firstLUp" }
const _hoisted_117 = { class: "pb-2 ulDueno" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-600" }, "Nombre que aparece en la tarjeta")
], -1))
const _hoisted_119 = { class: "mb-2" }
const _hoisted_120 = { class: "pb-2 ulDueno" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-600" }, "Nombre del banco")
], -1))
const _hoisted_122 = { class: "mb-2" }
const _hoisted_123 = { class: "pb-2 ulDueno" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-600" }, "Número de la tarjeta")
], -1))
const _hoisted_125 = { class: "mb-2" }
const _hoisted_126 = { class: "pb-2 ulDueno" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-600" }, "Fecha de operación")
], -1))
const _hoisted_128 = { class: "mb-2" }
const _hoisted_129 = {
  class: "modal fade",
  id: "confirmarModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  ref: "confirmarModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_130 = { class: "modal-dialog modal-dialog-centered mw-450px" }
const _hoisted_131 = { class: "modal-content rounded" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header pb-0 border-0 w-100",
  style: {"border-bottom":"1px solid #393840 !important"}
}, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-left fw-bold" }, "Cambio de estatus")
], -1))
const _hoisted_133 = {
  class: "modal-body pt-0",
  style: {"padding-left":"35px"}
}
const _hoisted_134 = { class: "row" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-5" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fw-bold",
    style: {"font-size":"17px"}
  }, "¿Desea cambiar el estatus de \"Retenido\" a \"Confirmado\"? Esta acción no se puede deshacer")
], -1))
const _hoisted_136 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 my-5 text-end" }
const _hoisted_137 = { style: {"list-style-type":"none","margin":"0","padding":"0","display":"inline-flex"} }
const _hoisted_138 = { class: "me-3" }
const _hoisted_139 = {
  class: "modal fade",
  id: "devolverModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  ref: "devolverModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_140 = { class: "modal-dialog modal-dialog-centered mw-450px" }
const _hoisted_141 = { class: "modal-content rounded" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header pb-0 border-0 w-100",
  style: {"border-bottom":"1px solid #393840 !important"}
}, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-left fw-bold" }, "Cambio de estatus")
], -1))
const _hoisted_143 = {
  class: "modal-body pt-0",
  style: {"padding-left":"35px"}
}
const _hoisted_144 = { class: "row" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-5" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fw-bold",
    style: {"font-size":"17px"}
  }, "¿Desea cambiar el estatus de \"Retenido\" a \"Devuelto\"? Esta acción no se puede deshacer")
], -1))
const _hoisted_146 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12 my-5 text-end" }
const _hoisted_147 = { style: {"list-style-type":"none","margin":"0","padding":"0","display":"inline-flex"} }
const _hoisted_148 = { class: "me-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("small", _hoisted_3, _toDisplayString(_ctx.titulo), 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            src: _ctx.portada,
            alt: "",
            class: "portada mt-5 mb-5"
          }, null, 8, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.nombreAuto), 1),
          _createElementVNode("p", _hoisted_11, "$ " + _toDisplayString(_ctx.precio), 1),
          _createVNode(_component_router_link, {
            class: "text-gray-800 text-hover-primary mb-1",
            to: { name: 'vehicles-detail', params: { id: _ctx.idVehicle } }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Ver detalles ")
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("h5", _hoisted_18, _toDisplayString(_ctx.vin), 1),
                  _hoisted_19,
                  _hoisted_20,
                  _createElementVNode("h5", _hoisted_21, _toDisplayString(_ctx.anio), 1),
                  _hoisted_22,
                  _hoisted_23,
                  _createElementVNode("h5", _hoisted_24, _toDisplayString(_ctx.brand), 1),
                  _hoisted_25,
                  _hoisted_26,
                  _createElementVNode("h5", _hoisted_27, _toDisplayString(_ctx.model), 1),
                  _hoisted_28,
                  _hoisted_29,
                  _createElementVNode("h5", _hoisted_30, _toDisplayString(_ctx.version), 1),
                  _hoisted_31,
                  _hoisted_32,
                  _createElementVNode("h5", _hoisted_33, _toDisplayString(_ctx.tipo), 1),
                  _hoisted_34,
                  _hoisted_35,
                  _createElementVNode("h5", _hoisted_36, _toDisplayString(_ctx.transmision), 1),
                  _hoisted_37,
                  _hoisted_38,
                  _createElementVNode("h5", _hoisted_39, _toDisplayString(_ctx.color), 1),
                  _hoisted_40,
                  _hoisted_41,
                  _createElementVNode("h5", _hoisted_42, _toDisplayString(_ctx.kilometraje) + " km", 1),
                  _hoisted_43
                ])
              ])
            ])
          ])
        ]),
        (_ctx.autoInteres != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("p", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.autoInteres), 1)
                ]),
                _createElementVNode("p", _hoisted_50, [
                  _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.autoInteresKm) + " KM", 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("span", null, "Apartado el: " + _toDisplayString(_ctx.fecha_apartado), 1)
          ]),
          ((_ctx.tipoRol != 'Agencia') || (_ctx.status != 'Retenido' && _ctx.tipoRol == 'Múltiples agencias'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _createElementVNode("ul", _hoisted_56, [
                  _hoisted_57,
                  ((_ctx.tipoRol != 'Múltiples agencias') || (_ctx.status != 'Retenido' && _ctx.tipoRol == 'Múltiples agencias'))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_58, [
                        _createElementVNode("button", {
                          style: {"pointer-events":"none"},
                          type: "button",
                          class: _normalizeClass(_ctx.status == 'Retenido' ? 'btn btn-primary': (_ctx.status == 'Confirmado' ? 'btn btn-success' : 'btn btn-danger'))
                        }, _toDisplayString(_ctx.status), 3)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.tipoRol == 'Múltiples agencias' && _ctx.status == 'Retenido')
            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  (_ctx.tipoRol == 'Múltiples agencias')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(_ctx.dropShow ? 'col-12 pe-2': 'col-12 pe-2'),
                        style: _normalizeStyle(_ctx.dropShow ? 'background-color: #28272C; border-radius: 10px 10px 0px 0px;':'')
                      }, [
                        _hoisted_61,
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary mb-2 mt-2",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mostrarDrop && _ctx.mostrarDrop(...args)))
                        }, [
                          _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.status), 1),
                          _createVNode(_component_inline_svg, {
                            src: "media/icons/iconsax/dropWhite.svg",
                            style: {"margin-left":"2px"}
                          })
                        ]),
                        (_ctx.status == 'Vendido')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(_ctx.status), 1))
                          : _createCommentVNode("", true)
                      ], 6))
                    : _createCommentVNode("", true),
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_ctx.dropShow)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            _createElementVNode("ul", _hoisted_65, [
                              _hoisted_66,
                              _createElementVNode("li", _hoisted_67, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmar && _ctx.confirmar(...args))),
                                  class: "btn btn-sm btn-success w-100"
                                }, "Confirmado")
                              ]),
                              _createElementVNode("li", _hoisted_68, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.devolver && _ctx.devolver(...args))),
                                  class: "btn btn-sm btn-danger w-100"
                                }, "Devuelto")
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _createElementVNode("ul", _hoisted_73, [
                _createElementVNode("li", _hoisted_74, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_inline_svg, { src: "media/icons/iconsax/Usuario.svg" }),
                    _createTextVNode("  " + _toDisplayString(_ctx.cliente_nombre), 1)
                  ])
                ]),
                _createElementVNode("li", _hoisted_75, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_inline_svg, { src: "media/icons/iconsax/Correo.svg" }),
                    _createTextVNode("  " + _toDisplayString(_ctx.cliente_correo), 1)
                  ])
                ]),
                _createElementVNode("li", _hoisted_76, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_inline_svg, { src: "media/icons/iconsax/Teléfono.svg" }),
                    _createTextVNode("  " + _toDisplayString(_ctx.cliente_telefono), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _hoisted_79,
              _createElementVNode("ul", _hoisted_80, [
                _createElementVNode("li", _hoisted_81, [
                  _createElementVNode("ul", _hoisted_82, [
                    _createElementVNode("li", null, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_inline_svg, { src: "media/icons/iconsax/shop.svg" })
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_83, _toDisplayString(_ctx.agencia_nombre), 1)
                  ])
                ]),
                _createElementVNode("li", _hoisted_84, [
                  _createElementVNode("ul", _hoisted_85, [
                    _createElementVNode("li", null, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_inline_svg, { src: "media/icons/iconsax/Correo.svg" })
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_86, _toDisplayString(_ctx.agencia_correo), 1)
                  ])
                ]),
                _createElementVNode("li", _hoisted_87, [
                  _createElementVNode("ul", _hoisted_88, [
                    _createElementVNode("li", null, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_inline_svg, { src: "media/icons/iconsax/Teléfono.svg" })
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_89, _toDisplayString(_ctx.agencia_telefono), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_90, [
          _createElementVNode("div", _hoisted_91, [
            _createElementVNode("div", _hoisted_92, [
              _hoisted_93,
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("ul", _hoisted_96, [
                    _createElementVNode("li", _hoisted_97, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_inline_svg, { src: "media/icons/iconsax/Recibo-receipt-2.svg" }),
                        _createTextVNode("  Cantidad")
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_98, [
                      _createElementVNode("span", null, "$ " + _toDisplayString(_ctx.tra_cantidad), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("ul", _hoisted_100, [
                    _createElementVNode("li", _hoisted_101, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_inline_svg, { src: "media/icons/iconsax/receipt-item.svg" }),
                        _createTextVNode("  No. Autorización")
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_102, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.tra_auth), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("ul", _hoisted_104, [
                    _createElementVNode("li", _hoisted_105, [
                      _createElementVNode("span", null, [
                        _createVNode(_component_inline_svg, { src: "media/icons/iconsax/calendar.svg" }),
                        _createTextVNode("  " + _toDisplayString(_ctx.tituloFecha), 1)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_106, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.tra_fecha), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("div", _hoisted_108, [
            _createElementVNode("div", _hoisted_109, [
              _hoisted_110,
              _createElementVNode("ul", _hoisted_111, [
                _hoisted_112,
                _createElementVNode("li", _hoisted_113, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.tar_tipo), 1)
                ])
              ]),
              _createElementVNode("ul", _hoisted_114, [
                _hoisted_115,
                _createElementVNode("li", _hoisted_116, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.tar_marca), 1)
                ])
              ]),
              _createElementVNode("ul", _hoisted_117, [
                _hoisted_118,
                _createElementVNode("li", _hoisted_119, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.tar_nombre), 1)
                ])
              ]),
              _createElementVNode("ul", _hoisted_120, [
                _hoisted_121,
                _createElementVNode("li", _hoisted_122, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.tar_banco), 1)
                ])
              ]),
              _createElementVNode("ul", _hoisted_123, [
                _hoisted_124,
                _createElementVNode("li", _hoisted_125, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.tar_tarjeta), 1)
                ])
              ]),
              _createElementVNode("ul", _hoisted_126, [
                _hoisted_127,
                _createElementVNode("li", _hoisted_128, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.tar_fecha), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_129, [
      _createElementVNode("div", _hoisted_130, [
        _createElementVNode("div", _hoisted_131, [
          _hoisted_132,
          _createElementVNode("div", _hoisted_133, [
            _createElementVNode("div", _hoisted_134, [
              _hoisted_135,
              _createElementVNode("div", _hoisted_136, [
                _createElementVNode("ul", _hoisted_137, [
                  _createElementVNode("li", _hoisted_138, [
                    _createElementVNode("button", {
                      class: "btn btn-secondary",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.descartarConfirmado && _ctx.descartarConfirmado(...args)))
                    }, " Descartar ")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendConfirmar && _ctx.sendConfirmar(...args)))
                    }, " Cambiar estatus ")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_139, [
      _createElementVNode("div", _hoisted_140, [
        _createElementVNode("div", _hoisted_141, [
          _hoisted_142,
          _createElementVNode("div", _hoisted_143, [
            _createElementVNode("div", _hoisted_144, [
              _hoisted_145,
              _createElementVNode("div", _hoisted_146, [
                _createElementVNode("ul", _hoisted_147, [
                  _createElementVNode("li", _hoisted_148, [
                    _createElementVNode("button", {
                      class: "btn btn-secondary",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.descartarDevuelto && _ctx.descartarDevuelto(...args)))
                    }, " Descartar ")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.sendDevolver && _ctx.sendDevolver(...args)))
                    }, " Cambiar estatus ")
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 512)
  ]))
}